export enum BIEvent {
	SIGNUP_CLICK_STEP1 = 50000,
	SIGNUP_SUCCESS_STEP1 = 50001,
	SIGNUP_FAILED_STEP1 = 50002,
	SIGNUP_CLICK_STEP2 = 50010,
	SIGNUP_SUCCESS_STEP2 = 50011,
	SIGNUP_FAILED_STEP2 = 50012,
	LOGIN_REDIRECT_SUCCESS = 50050,
	LOGIN_REDIRECT_FAIL = 50060,
	LOGIN_NEXT_CLICK = 50070,
	SSO_SIGNUP_CLICK = 51001,
	PAGE_VIEW = 51002,

	// DEPRECATED
	SUBDOMAIN_TAKEN = 50021,
	SIGNUP_VALIDATION_SERVER = 50030,
	LOGIN_CLICK = 50040,
	GET_STARTED_CLICK = 51000,
}
